import {
  QueryHookOptions,
  useQuery,
} from '@apollo/client';

import { GET_WORK_ITEMS } from '@frontend/app/queries';
import { useMemo } from 'react';
import {
  GetWorkItemsQuery,
  GetWorkItemsQueryVariables,
} from '../queries/types/GetWorkItemsQuery';

type IOptions = QueryHookOptions<GetWorkItemsQuery, GetWorkItemsQueryVariables>;

export const useGetWorkItemsQuery = (options: IOptions = {}) => {
  const {
    data,
    loading,
    refetch,
  } = useQuery<GetWorkItemsQuery, GetWorkItemsQueryVariables>(GET_WORK_ITEMS, options);

  return useMemo(() => ({
    workItems: data?.workItems || [],
    isWorkItemsLoading: loading,
    refetchWorkItems: refetch,
  }), [data, loading, refetch]);
};
